<template>
  <table class="condition-search">
    <tr v-for="condition in conditionsSearch">
      <td class="el-col field-search">
        <span>{{ condition.fieldLabel }}</span> <br>
        <el-link :underline="false" class="btn-add-edit" v-if="condition.hasBtnAdd" @click="$emit('handleAddConditionSearch', condition.type)">
          {{ $t('profits.add_edit')}}
        </el-link>
      </td>
      <td class="el-col data">
        <el-checkbox-group class="checkbox-search">
          <el-checkbox :label="item.id" :key="item.id" v-for="item in condition.data">
            {{ item.name }}
          </el-checkbox>
        </el-checkbox-group>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  props: {
    class: { type: String, required: false, default: '' },
    conditionsSearch: { type: Object, required: false, default: {} },
  }
}
</script>

<style lang="scss" scope>
  .condition-search {
    .el-checkbox-group {
      .el-checkbox  {
        margin-bottom: 20px;
      }
    }
  }
</style>
